import styles from "./LoadingScreen.module.css"
import img from "../../assets/images/loading.svg"

const LoadingScreen = () => {
    return (
        <div>
        </div>
    );
};

export default LoadingScreen;
